import {
  SEND_OTP,
  SEND_OTP_SUCCESSFUL,
  SEND_OTP_FAILED,  VERIFY_OTP, VERIFY_OTP_FAILED, VERIFY_OTP_SUCCESSFUL

} from "./actionTypes"

const initialState = {
  message: null,
  loading: false,
}

 /**
      * Used for handling data and callbacks
      */


const account = (state = initialState, action) => {
  switch (action.type) {
    case SEND_OTP:
      return {
        ...state,
        user: null,
        loading: true,
      }

    case SEND_OTP_SUCCESSFUL:
      return {
        ...state,
        loading: false,
      }

    case SEND_OTP_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
      }

      case VERIFY_OTP:
        return {
          ...state,
          user: null,
          loading: true,
        }
  
      case VERIFY_OTP_SUCCESSFUL:
        return {
          ...state,
          loading: false,
        }
  
      case VERIFY_OTP_FAILED:
        return {
          ...state,
          user: null,
          loading: false,
        }

    default:
      return state
  }
}

export default account
